import React from 'react';
import PropTypes from 'prop-types';

function CustomPaginationContainer({
  maxPage = 0,
  nextText = '',
  previousText = '',
  currentPage = 0,
  customPagerComponentOptions = {},
  customPagerComponent: PagerComponent,
  setPage,
  previous,
  next,
}) {
  return typeof PagerComponent === 'function' ? (
    <PagerComponent
      {...customPagerComponentOptions}
      maxPage={maxPage}
      nextText={nextText}
      previousText={previousText}
      currentPage={currentPage}
      setPage={setPage}
      previous={previous}
      next={next}
    />
  ) : (
    <div />
  );
}

CustomPaginationContainer.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  setPage: PropTypes.func,
  maxPage: PropTypes.number,
  currentPage: PropTypes.number,
  nextText: PropTypes.string,
  previousText: PropTypes.string,
  customPagerComponentOptions: PropTypes.func,
};

export { CustomPaginationContainer };
